import { LOGIN, HOME, ExportMail, Games } from "./routeNames";
import store from "@/store";
import { checkAccessToken } from "../utils/authentHelpers";
import { upperFirst } from "lodash";

const anonymousPages = [LOGIN];

// verify if the user is connected and have the required right
// TODO the rights aren't set yet
export const authenticationGuard = (router) => (to, from, next) => {
  // Récupération des jetons de sécurité depuis l'url lorsqu'on utilise vuejs en accès programmatique (notificationserver)
  if (to.query["accessToken"]) {
    store.commit("authentication/initFromUri", to.query["accessToken"]);
  } else {
    store.commit("authentication/init");
  }

  const meta = to.meta;
  const hasAccess = store.getters["authentication/hasRight"];

  if (!anonymousPages.includes(to.name) && !checkAccessToken(store)) {
    next({ name: LOGIN, query: { redirectFrom: to.fullPath } });
  } else if (meta.requiredRoleRank !== undefined) {
    // Si l'utilisateur n'a pas assez de droit, on le redirige
    const userRoleRank = store.getters["authentication/getRoleRank"];
    if (userRoleRank > meta.requiredRoleRank) {
      const fallbackRoute = meta.fallbackRouteName || HOME;
      next({ name: fallbackRoute });
    }
    next();
  } else if (meta.requiredRight && !hasAccess(meta.requiredRight)) {
    const fallbackRoute = meta.fallbackRouteName || HOME;

    next({ name: fallbackRoute });

    router.app.$toastr.e("Access Restricted");
  } else {
    next();
  }
};
